<!-- start section knowledge tabs -->
<section class="FT-knowledge-tabs" *ngIf="!calculatorPage">
  <div class="container">
    <div class="FT-title-small text-medium">{{ "ftiGeneric.where-do-you-stand-card-title" | translate }}</div>
    <div class="row">
      <div class="col-md-auto">
        <div class="nav nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
          <button class="nav-link active" id="v-pills-home-tab" data-bs-toggle="pill"
                  data-bs-target="#v-pills-home" type="button" role="tab" aria-controls="v-pills-home"
                  aria-selected="true">
            <img alt='{{ "ftiGeneric.where-do-you-stand-tab1-label" | translate }}'
                 src='{{ "ftiGeneric.where-do-you-stand-tab1-icon" | translate }}'>
            {{ "ftiGeneric.where-do-you-stand-tab1-label" | translate }}
          </button>
          <button class="nav-link" id="v-pills-profile-tab" data-bs-toggle="pill"
                  data-bs-target="#v-pills-profile" type="button" role="tab" aria-controls="v-pills-profile"
                  aria-selected="false">
            <img alt='{{ "ftiGeneric.where-do-you-stand-tab2-label" | translate }}'
                 src='{{ "ftiGeneric.where-do-you-stand-tab2-icon" | translate }}'>
            {{ "ftiGeneric.where-do-you-stand-tab2-label" | translate }}
          </button>
          <button class="nav-link" id="v-pills-disabled-tab" data-bs-toggle="pill"
                  data-bs-target="#v-pills-disabled" type="button" role="tab" aria-controls="v-pills-disabled"
                  aria-selected="false">
            <img alt='{{ "ftiGeneric.where-do-you-stand-tab3-label" | translate }}'
                 src='{{ "ftiGeneric.where-do-you-stand-tab3-icon" | translate }}'>
            {{ "ftiGeneric.where-do-you-stand-tab3-label" | translate }}
          </button>
        </div>
      </div>
      <div class="col-md">
        <div class="tab-content" id="v-pills-tabContent">
          <div class="tab-pane fade show active" id="v-pills-home" role="tabpanel"
               aria-labelledby="v-pills-home-tab" tabindex="0">
            <div class="kc-confused-form">
              <h3 class="mb-4">{{ "ftiGeneric.where-do-you-stand-form-title" | translate }}</h3>
              <ft-call-back-form [isSmall]="true" [isCallback]="true"></ft-call-back-form>
            </div>
          </div>

          <!-- Plan your goal block -->
          <div class="tab-pane fade" id="v-pills-profile" role="tabpanel"
               aria-labelledby="v-pills-profile-tab" tabindex="0">
            <div class="plan-box">
             <!-- <div>
                <h3 class="d-flex align-items-center justify-content-between mb-4">
                  {{ "ftiGeneric.where-do-you-stand-tab2-solution-card-title" | translate }}
                  <a class="knowledge-center-CTA"
                     href='{{ "ftiGeneric.where-do-you-stand-tab2-solution-card-view-all-link" | translate }}'
                     target='{{ "ftiGeneric.where-do-you-stand-tab2-solution-card-view-all-target" | translate }}'>
                    <span
                        class="otherlinks login-dark2 ">{{ "ftiGeneric.where-do-you-stand-view-all-text" | translate }}</span>
                    <i class="bi bi-chevron-right"></i>
                  </a>
                </h3>
                <div class="choose-plan-wraper">
                  <div class="choose-plan-card">
                    <div class="img-wrap">
                      <img alt="image" src='{{ "ftiGeneric.where-do-you-stand-tab2-solution-card1-image" | translate }}' alt="">
                    </div>
                    <div
                        class="choose-plan-title">{{ "ftiGeneric.where-do-you-stand-tab2-solution-card1-text" | translate }}
                    </div>
                  </div>

                  <div class="choose-plan-card">
                    <div class="img-wrap">
                      <img alt="image" src='{{ "ftiGeneric.where-do-you-stand-tab2-solution-card2-image" | translate }}' alt="">
                    </div>
                    <div
                        class="choose-plan-title">{{ "ftiGeneric.where-do-you-stand-tab2-solution-card2-text" | translate }}
                    </div>
                  </div>

                  <div class="choose-plan-card">
                    <div class="img-wrap">
                      <img alt="image" src='{{ "ftiGeneric.where-do-you-stand-tab2-solution-card3-image" | translate }}' alt="">
                    </div>
                    <div
                        class="choose-plan-title">{{ "ftiGeneric.where-do-you-stand-tab2-solution-card3-text" | translate }}
                    </div>
                  </div>

                  <div class="choose-plan-card">
                    <div class="img-wrap">
                      <img alt="image" src='{{ "ftiGeneric.where-do-you-stand-tab2-solution-card4-image" | translate }}' alt="">
                    </div>
                    <div
                        class="choose-plan-title">{{ "ftiGeneric.where-do-you-stand-tab2-solution-card4-text" | translate }}
                    </div>
                  </div>
                </div>
              </div>-->
              <h3 class="d-flex align-items-center justify-content-between mb-4 mt-5">
                {{ "ftiGeneric.where-do-you-stand-tab2-calculator-card-title" | translate }}
                <a class="knowledge-center-CTA"
                   href='{{ "ftiGeneric.where-do-you-stand-tab2-calculator-card-view-all-link" | translate }}'
                   target='{{ "ftiGeneric.where-do-you-stand-tab2-solution-card-view-all-target" | translate }}'>
                  <span
                      class="otherlinks login-dark2 ">{{ "ftiGeneric.where-do-you-stand-view-all-text" | translate }}</span>
                  <i class="bi bi-chevron-right"></i>
                </a>
              </h3>
              <div class="row justify-content-center">
                <div class="row scrollnextgo">
                  <div class="col-md-4 col-sm-6 col-10 mb-3 mb-md-4">
                    <div class="calc-box">
                      <img src='{{ "ftiGeneric.where-do-you-stand-tab2-calculator-card1-image" | translate }}'
                           alt='{{ "ftiGeneric.where-do-you-stand-tab2-calculator-card1-text" | translate }}'>
                      <a (click)="triggerGA('ftiGeneric.where-do-you-stand-tab2-calculator-card1-text')" href='{{ "ftiGeneric.where-do-you-stand-tab2-calculator-card1-link" | translate }}'
                         class="btn btn-primary"
                         target='{{ "ftiGeneric.where-do-you-stand-tab2-calculator-card1-target" | translate }}'>
                        {{ "ftiGeneric.where-do-you-stand-tab2-calculator-card1-text" | translate }}</a>
                    </div>
                  </div>

                  <div class="col-md-4 col-sm-6 col-10 mb-3 mb-md-4">
                    <div class="calc-box">
                      <img src='{{ "ftiGeneric.where-do-you-stand-tab2-calculator-card2-image" | translate }}'
                           alt='{{ "ftiGeneric.where-do-you-stand-tab2-calculator-card2-text" | translate }}'>
                      <a href='{{ "ftiGeneric.where-do-you-stand-tab2-calculator-card2-link" | translate }}'
                         class="btn btn-primary"
                         target='{{ "ftiGeneric.where-do-you-stand-tab2-calculator-card2-target" | translate }}'>
                        {{ "ftiGeneric.where-do-you-stand-tab2-calculator-card2-text" | translate }}</a>
                    </div>
                  </div>

                  <div class="col-md-4 col-sm-6 col-10 mb-3 mb-md-4">
                    <div class="calc-box">
                      <img src='{{ "ftiGeneric.where-do-you-stand-tab2-calculator-card3-image" | translate }}'
                           alt='{{ "ftiGeneric.where-do-you-stand-tab2-calculator-card3-text" | translate }}'>
                      <a href='{{ "ftiGeneric.where-do-you-stand-tab2-calculator-card3-link" | translate }}'
                         class="btn btn-primary"
                         target='{{ "ftiGeneric.where-do-you-stand-tab2-calculator-card3-target" | translate }}'>
                        {{ "ftiGeneric.where-do-you-stand-tab2-calculator-card3-text" | translate }}</a>
                    </div>
                  </div>
                  <!--<div class="col-md-4 col-sm-6 col-10 mb-3 mb-md-4">
                    <div class="calc-box">
                      <img src='{{ "ftiGeneric.where-do-you-stand-tab2-calculator-card4-image" | translate }}'
                           alt='{{ "ftiGeneric.where-do-you-stand-tab2-calculator-card4-text" | translate }}'>
                      <a href='{{ "ftiGeneric.where-do-you-stand-tab2-calculator-card4-link" | translate }}'
                         class="btn btn-primary"
                         target='{{ "ftiGeneric.where-do-you-stand-tab2-calculator-card4-target" | translate }}'>
                        {{ "ftiGeneric.where-do-you-stand-tab2-calculator-card4-text" | translate }}</a>
                    </div>
                  </div>
                  <div class="col-md-4 col-sm-6 col-10 mb-3 mb-md-4">
                    <div class="calc-box">
                      <img src='{{ "ftiGeneric.where-do-you-stand-tab2-calculator-card5-image" | translate }}'
                           alt='{{ "ftiGeneric.where-do-you-stand-tab2-calculator-card5-text" | translate }}'>
                      <a href='{{ "ftiGeneric.where-do-you-stand-tab2-calculator-card5-link" | translate }}'
                         class="btn btn-primary"
                         target='{{ "ftiGeneric.where-do-you-stand-tab2-calculator-card5-target" | translate }}'>
                        {{ "ftiGeneric.where-do-you-stand-tab2-calculator-card5-text" | translate }}</a>
                    </div>
                  </div>
                  <div class="col-md-4 col-sm-6 col-10 mb-3 mb-md-4">
                    <div class="calc-box">
                      <img src='{{ "ftiGeneric.where-do-you-stand-tab2-calculator-card6-image" | translate }}'
                           alt='{{ "ftiGeneric.where-do-you-stand-tab2-calculator-card6-text" | translate }}'>
                      <a href='{{ "ftiGeneric.where-do-you-stand-tab2-calculator-card6-link" | translate }}'
                         class="btn btn-primary"
                         target='{{ "ftiGeneric.where-do-you-stand-tab2-calculator-card6-target" | translate }}'>
                        {{ "ftiGeneric.where-do-you-stand-tab2-calculator-card6-text" | translate }}</a>
                    </div>
                  </div>-->
                </div>
              </div>
            </div>
          </div>
          <!--Ready to invest block-->
          <div *ngIf="isLoaded" class="tab-pane fade" id="v-pills-disabled" role="tabpanel"
               aria-labelledby="v-pills-disabled-tab" tabindex="0">
            <h3 class="d-flex align-items-center justify-content-between ">{{ "products.focus-card-ready-to-invest" | translate }}
              <a class="knowledge-center-CTA" href="{{ 'products.focus-card-view-all-link' | translate }}">
                <span class="otherlinks login-dark2 ">{{ "products.focus-card-view-all" | translate }}</span>
                <i class="bi bi-chevron-right"></i>
              </a>
            </h3>
            <div class="mb-4 d-none d-md-inline-block">{{ "products.focus-card-description" | translate }}</div>
            <div class="row scrollnextgo" *ngIf="fundCardsData.length; else fundCardsEmpty">
              <ng-container *ngFor="let fundCard of fundCardsData; let i = index;">
                <div class="col-md-6" *ngIf="i < 4">
                  <ft-focus-fund-card [fund]="fundCard"></ft-focus-fund-card>
                </div>
              </ng-container>
            </div>
            <ng-template #fundCardsEmpty>
              <span>{{ "products.fund-cards-no-card-data" | translate }}</span>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- start section fund returns -->
<div *ngIf="calculatorPage && fundDataAll?.length">
  <section class="FT-returns mb-6">
    <div class="container">
      <div class="bg-gradient">
        <div class="d-flex head text-white">
          <div class="FT-title-medium">{{ "products.sip-calc-check-fund-returns" | translate }}</div>
          <button class="btn btn-white d-none d-md-block" data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasExample"
                  aria-controls="offcanvasExample">
            {{ "products.calc-returns-check-now" | translate }}
          </button>
          <button class="btn btn-white d-md-none" data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasBottom1"
                  aria-controls="offcanvasBottom">
            {{ "products.calc-returns-check-now" | translate }}
          </button>
        </div>
      </div>
    </div>
  </section>

  <div *ngIf="!isMobileView">
    <div class="offcanvas offcanvas-end custom-offcanvas" tabindex="-1" id="offcanvasExample"
         aria-labelledby="offcanvasExampleLabel" style="z-index: 100000000;">
      <div class="offcanvas-body darkOffcanvasAddbody">
        <ft-empty-page
            [brConfiguration]="brConfiguration"
            [fundData]="fundDataAll"
            [sideFilterOptions]="sideFilterOptions"
            [comaredCardImg]="false"
            [cardTypeData]="'CALCULATOR'"
            [addFundData]="true"
            pageSubHeading="">
        </ft-empty-page>
      </div>
    </div>
  </div>
</div>

<!-- offcanvas mobile-->
<ng-container *ngIf="isMobileView && fundDataAll?.length">
  <div class="offcanvas offcanvas-bottom for-add-offcanvas-bottom calc-offcanvas" tabindex="-1" id="offcanvasBottom1"
       aria-labelledby="offcanvasBottomLabel"
       style="height: 50%; border-top-left-radius: 39px; border-top-right-radius: 39px;">
    <div class="offcanvas-header">
      <span class="line"></span>
    </div>
    <div class="offcanvas-body small" style="max-height: 500px; overflow-y: auto; padding:10px 0;">
      <ft-empty-page
          [brConfiguration]="brConfiguration"
          [fundData]="fundDataAll"
          [sideFilterOptions]="sideFilterOptions"
          [comaredCardImg]="false"
          [hasThreeDotOptions]="true"
          [cardTypeData]="'CALCULATOR'"
          [addFundData]="true"
          [isMobileAdd]="true"
          pageSubHeading="">
      </ft-empty-page>
    </div>
  </div>
</ng-container>
